export const phoneFormatter = (phone = '', initial = 3) => phone?.slice(initial);
export const moneyFormatter = (amount, currency, decimals = 2) => `${currency} ${(amount + 0).toFixed(decimals)}`;
export const dateFormatter = (date) => new Date(date).toLocaleString('en-GB').split(',')[0];

export const datetimeFormatter = (date, timeZone, hour12 = false) => {
  try {
    return new Date(date)
      .toLocaleString('en-GB', { hour12, timeZone })
      .toUpperCase()
      .replace(', ', ' - ');
  } catch {
    return new Date(date)
      .toLocaleString('en-GB', { hour12 })
      .toUpperCase()
      .replace(', ', ' - ');
  }
};

export const numbersFormatter = (numbers, length = 8) => {
  const regex = /\D/g;
  return numbers.replace(regex, '').substring(0, length);
};

export default {
  phone: phoneFormatter,
  money: moneyFormatter,
  date: dateFormatter,
  datetime: datetimeFormatter,
  numbers: numbersFormatter
};
